import { eManualCheckDisbursementCategory } from '../../../../../../types/accounting/eManualCheckDisbursementCategory';

const issuanceDateCategories: string[] = [
  eManualCheckDisbursementCategory.commission,
  eManualCheckDisbursementCategory.due_to_borrower,
  eManualCheckDisbursementCategory.due_to_seller,
];

export const isIssuanceDateCategory = (category?: string) => {
  if (!category) {
    return false;
  }
  return issuanceDateCategories.includes(category);
};
